import React, { useEffect, useState } from "react";
import "./Category_section.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import {
  getAllCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";

import Category_Subcategory_Card from "../../common-components/category_subcategory_card/Category_Subcategory_Card";
import Common_heading_holder from "../../common-components/common_heading_holder/Common_heading_holder";

const Category_section = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [status, setStatus] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");

  // Redux state
  const category = useSelector((state) => state?.master?.categories);
  console.log(category, "testcategory");

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleCategoryClick = (category_id) => {
    console.log("handleCategoryClick", category_id);
    setStatus("");
    setSelectedCategoryId(category_id);
    dispatch(getAllSubCategory({ category_id }));
  };

  return (
    <section className="Category_section">
      <div className="container-fluid">
        <Common_heading_holder heading_text="Explore Collection" />

        <div className="cat_subcat_div">
          {status === "noCategory" ? (
            <p className="text-danger">No category available.</p>
          ) : (
            <Swiper
              className="mySwiper"
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              loop={true}
              modules={[Pagination]}
              breakpoints={{
                0: { slidesPerView: 3, spaceBetween: 10 },
                350: { slidesPerView: 4, spaceBetween: 10 },
                576: { slidesPerView: 4, spaceBetween: 10 },
                768: { slidesPerView: 5, spaceBetween: 10 },
                992: { slidesPerView: 6, spaceBetween: 10 },
                1200: { slidesPerView: 8, spaceBetween: 10 },
              }}
            >
              {category?.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="product-slide">
                    <Nav.Item>
                      <Nav.Link
                        eventKey={slide?.id}
                        active={selectedCategoryId === slide?.id}
                        onClick={() => {
                          setSelectedCategoryId(slide?.id);
                          navigate(`/categories?category_id=${slide?.id}`, {
                            state: { category_id: slide?.id },
                          });
                        }}
                      >
                        <Category_Subcategory_Card
                          className="product-image"
                          content={slide?.name}
                          image={process.env.REACT_APP_IMG_URL + slide?.image}
                          imgClassName="category-image"
                        />
                        
                      </Nav.Link>
                    </Nav.Item>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default Category_section;
